module.exports = {"cheggBaseUrl":"https://trunk.live.test.cheggnet.com","graphBaseUrl":"https://gateway.test.cheggnet.com/digital-pricing-bff/graphql"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/Config/app-config.development.json
// module id = 3406
// module chunks = 11